<template>
  <div>
    <div class="headingWizard">Manage LTA Appointments</div>

    <div class="bgHomeView">
      <div class="textHeadingHome">
        <p>
          Services at LTA's Customer Service Centre are strictly by appointment only and are for transactions that
          cannot be completed online. For greater convenience, please complete your transaction online using our
          <b>
            <a href="https://onemotoring.lta.gov.sg/content/onemotoring/home/digitalservices.html"
              target="_blank">Digital Services</a>
          </b>.
        </p>

        <p>For more information on other services:</p>
        <ul class="headingList">
          <li>
            To submit an appeal against an offence online, click
            <b>
              <a href="https://onemotoring.lta.gov.sg/content/onemotoring/home/digitalservices/Submit_an_Appeal.html"
                target="_blank">here</a>
            </b>
          </li>
          <li>
            To apply for a vocational licence online (Singpass login required), click
            <b>
              <a href="https://www.gobusiness.gov.sg/licences/" target="_blank">here</a>
            </b>
          </li>
          <li>
            For all other digital services (Singpass login required for some services), click
            <b>
              <a href="https://onemotoring.lta.gov.sg/content/onemotoring/home/digitalservices.html"
                target="_blank">here</a>
            </b>
          </li>
        </ul>

        <p>Make an appointment only if your transaction <b>cannot be carried out online</b>.</p>
        <p>Appointments can only be made 2 working days or more in advance.</p>
      </div>

      <div class="dtable">
        <div class="centerAlign">
          <span class="actionImg">
            <a class="d-block" href="javascript:void(0)" @click="makeNewAppointment">
              <img class="icon" src="../../assets/newApp.png" />
              <span class="textButton">Make New Appointment</span>
            </a>
          </span>
          <span class="actionImg">
            <a class="d-block" href="javascript:void(0)" @click="enquireAppointment">
              <img class="icon" src="../../assets/enquirApp.png" />
              <span class="textButton">Enquire / Manage Appointment</span>
            </a>
          </span>
        </div>
      </div>

      <div class="textHeadingHome">
        <p>
          Please note that by accessing and/or using any part of this website and/or the online services, you shall be
          deemed to have accepted to be legally bound by the OneMotoring Terms of Use, which is accessible via
          <a href="https://onemotoring.lta.gov.sg/content/onemotoring/home/topwebsite/terms-of-use.html"
            target="_blank">https://onemotoring.lta.gov.sg/content/onemotoring/home/topwebsite/terms-of-use.html</a>
        </p>
      </div>
    </div>
  </div>
</template>


<script setup>
import { onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const store = useStore()
const router = useRouter()

onBeforeMount(() => {
  store.dispatch('reset')
})

const makeNewAppointment = () => {
  router.push({ path: '/newappointment' })
}

const enquireAppointment = () => {
  router.push({ path: '/enquireappointment/1' })
}
</script>

<style>
.d-block {
  display: block;
}

.actionImg {
  margin: 10px 50px;
  display: inline-block;
}

.textButton {
  display: block;
  color: #3a3a3a;
}
a{
  text-decoration: none !important;
}
.dtable {
  height: calc(100vh - 398px);
  width: 100%;
  display: table;
}

.centerAlign {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

img.icon {
  max-width: 150px;
  cursor: pointer;
}

.textHeadingHome a {
  color: #007ad9;
  text-decoration: underline !important;
}

p {
  font-size: 16px;
  color: #000;
}

.bgHomeView {
  background: #f5f5f5;
  padding: 40px 50px;
  height: initial;
}

@media all and (min-width: 696px) {
  .bgHomeView {
    background: #f5f5f5;
    padding: 99px 50px;
    height: calc(100vh - 0px);
  }
}
</style>
